<template>
  <div class="submenu">
    <h5>{{mainTitle}}</h5>
    <ul>
      <li v-for="item in subMenuList" :key="item.id" v-if="item.meta.level == 2" :class="isActive(item)?'active':''">
        <router-link :to="{ path: item.path }">
          {{item.meta.title}}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LayoutSubMenu',
  props: ['mainTitle', 'subMenuList'],
  methods: {
    isActive(router) {
      if (this.$route.meta.level > 2) {
        return this.$route.meta.parent_name === router.name
      } else {
        return this.$route.name === router.name
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/subMenu.vue